export const textfieldMix = {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },    

    errorMessages : {
      type: [String,Array],
      default: ()=>[] 
    },
 
    rules : {
      type: [String,Array],
      default: ()=>[] 
    }, 

    label: {
      type: String,
      default: null
    },

    placeholder: {
      type: String,
      default: ''
    },  

    hideDetails: {
      type: [String,Boolean],
      default: false
    },  

    readonly : {
      type: Boolean,
      default: false 
    },

    disabled: {
      type: Boolean,
      default: false
    },  

    solo : {
      type: Boolean,
      default: false 
    },

    suffix : {
      type: String,
      default: ''
    }, 

    maxlength: {
      type: String,
      default: ''
    },
  },

}